const shadows = {
  max:
    ' 0 0 0 1px rgba(136, 152, 170, .08), 0 15px 35px 0 rgba(49, 49, 93, .1), 0 5px 15px 0 rgba(0, 0, 0, .08)',
  min: '0 5px 15px 0 rgba(0, 0, 0, .08)',
};

export default shadows;
